import userProfileSection from "../../components/userProfileSection/index.vue";

export default {
  name: "profilePage",
  components: {
    userProfileSection,
  },
};
